/**
 * Which patient-list tab is open, kept across the chart round-trip (BAR-2786).
 *
 * In the URL, so browser back restores it, and in the session, because the nav
 * link to the list carries no parameter. A value that is not a known tab is
 * ignored rather than trusted — both stores outlive a deploy that renames one.
 */

import { PATIENT_PAGE_FILTER_OPTIONS, PatientPageFilterOption } from '@bariendo/lib/constants';

export const LIST_FILTER_PARAM = 'list';
export const LIST_FILTER_STORAGE_KEY = 'orbit.patient-list.filter';

function isListFilter(value: string | null): value is PatientPageFilterOption {
  return (Object.values(PATIENT_PAGE_FILTER_OPTIONS) as string[]).includes(value ?? '');
}

/** The URL's tab, else the session's, else My patients. */
export function initialListFilter(fromUrl: string | null): PatientPageFilterOption {
  if (isListFilter(fromUrl)) {
    return fromUrl;
  }

  const fromSession = sessionStorage.getItem(LIST_FILTER_STORAGE_KEY);
  return isListFilter(fromSession) ? fromSession : PATIENT_PAGE_FILTER_OPTIONS.MY_PATIENTS;
}

export function rememberListFilter(filter: PatientPageFilterOption): void {
  sessionStorage.setItem(LIST_FILTER_STORAGE_KEY, filter);
}
